type Words = string[];

const words: Words = [
  "apple",
  "beach",
  "aisle",
  "jelly",
  "lucky",
  "juice",
  "pluck",
  "wheat",
  "twirl",
  "swirl",
  "table",
  "light",
  "arrow",
];

export default words;
